import { Text, Flex, Fieldset, Grid } from "@chakra-ui/react";
import { CheckboxCard } from "@/components/ui/checkbox-card";
import { Annotation, AnnotationBody, ImageAnnotation, useAnnotator } from "@annotorious/react";
import { HEALTH_ISSUES } from "../health_issues";
import ObservationStatus from "../../ObservationStatus";

interface IHealthIssuesFieldset {
  editMode: boolean;
  annotations: Annotation[];
  selectedAnnotations:{ annotation: ImageAnnotation; editable?: boolean | undefined; }[]
  status?: "created" | "processing" | "completed" | "failed";
}
function HealthIssuesFieldset({
  annotations,
  selectedAnnotations,
  editMode,
  status,
}: IHealthIssuesFieldset) {
  const anno = useAnnotator();

  const toggleIssue = (issue: string) => {
    if (selectedAnnotations.length) {
      const { annotation } = selectedAnnotations[0];
      const issues = annotation.bodies.map((b: AnnotationBody) => b.id);
      if (issues.includes(issue)) {
        annotation.bodies = annotation.bodies.filter((b: AnnotationBody) => b.id !== issue);
      } else {
        annotation.bodies.push({
          id: issue,
          annotation: (annotation as Annotation).id,
          purpose: "classifying",
          value: "1.0"
        });
      }
      anno.updateAnnotation({ ...annotation });
    }
  };
  const getLabelCount = (issueId: string) => {
    const count = annotations.filter(
      (a) => a.bodies.find((b) => b.id === issueId)
    ).length;
    return count ? `(${count})` : "";
  };
  const numOfIssues = annotations.reduce(
    (acc, { bodies }) => (acc += bodies.length),
    0
  );
  return(
    <Fieldset.Content mt="2">
      <Flex justifyContent="space-between" flexWrap="wrap" alignItems="center">
        <Text fontSize="sm">
          <strong>{annotations.length}</strong> Fragments&ensp;|&ensp;
          {numOfIssues}{" "}
          Issue{numOfIssues == 1 ? "" : "s"}
        </Text>
        {status &&
          <ObservationStatus status={status} />}
      </Flex>
      <Grid templateColumns={{ base: "repeat(3, 1fr)", md: "1fr" }} gap={{base: "4", md: "2" }}>
        {HEALTH_ISSUES.map((issue) => (
          <CheckboxCard
            key={issue.value}
            label={`${issue.label} ${getLabelCount(issue.value)}`}
            checked={
              selectedAnnotations.length
                ? selectedAnnotations[0].annotation.bodies
                  .map((b) => b.id)
                  .includes(issue.value)
                : false
            }
            size="sm"
            fontSize={{base: "xs", md: "sm"}}
            variant="surface"
            colorPalette={issue.color}
            onCheckedChange={() => toggleIssue(issue.value)}
            disabled={editMode ? selectedAnnotations.length === 0 : true}
            opacity="1"
          />
        ))}
      </Grid>
    </Fieldset.Content>
  );
}

export default HealthIssuesFieldset;
